import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { stringify } from 'querystring';
import { TITLE } from 'src/app/utils/enum';
import { FormFieldInfo } from '../../../../models/forms-response.models';

@Component({
    selector: 'app-component-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxComponent implements OnInit, AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    @Input() formGroup: FormGroup;
    @Input() modalTitle:any;
    @Input() formData: any;
    formFieldConfig: any;
    fieldConfig: any;
    name: string;
    maxlength: string = '';
    hideTitle: boolean;
    defaultValue: boolean = false;
    tooltip: string;
    fieldCode: string;
    fieldDataInfo:any;
    taxcode="";
    formCode="";

    constructor(private cdref: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        try {
            this.formFieldConfig = this.formFieldInfo.formFieldConfig ? JSON.parse(this.formFieldInfo.formFieldConfig) : "";
            this.fieldConfig = this.formFieldInfo.fieldConfig ? JSON.parse(this.formFieldInfo.fieldConfig) : "";
            this.fieldCode = this.formFieldInfo.fieldCode;
            this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
            this.name = (this.formFieldConfig && this.formFieldConfig.displayText) ? this.formFieldConfig.displayText : this.formFieldInfo.name;
            this.tooltip = this.formFieldConfig && this.formFieldConfig.tooltip ? this.formFieldConfig.tooltip : "";
            this.fieldDataInfo=this.formFieldInfo;
            this.formCode=localStorage.getItem('FORM_CODE');
            this.taxcode=localStorage.getItem('TAXCODE');
            this.defaultValue = (this.formFieldInfo.defaultValue && (this.formFieldInfo.defaultValue != "")) ? true : false;
            this.bindingData();
        } catch (error) {
            this.formFieldConfig = JSON.parse('{ "pattern": "" }');
            this.fieldConfig = JSON.parse('{ "keydownPattern": "" }');
        }
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    modelChange() {
        localStorage.setItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxcode + '_'+ this.fieldCode, this.defaultValue.toString());
    }
    bindingData(){
        if (this.modalTitle == TITLE.ADD_DATA)//This case is: Click icon(+) to open popup
        {
            this.defaultValue = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? true : false;
        }
        else if (this.modalTitle == TITLE.UPDATE_DATA) { //This case is: Click icon(edit) to open popup
            if (this.formData) {
                let objectData = this.formData;
                const keys = Object.keys(objectData);
                keys.forEach((key) => {
                    if (key == this.formFieldInfo.fieldCode) {
                        let value = objectData[key];
                        this.defaultValue = value;
                    }
                });
            }
        }
        else {
            let storageVal = localStorage.getItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxcode + '_'+ this.fieldCode);
            if (storageVal) {
                this.defaultValue = true;
            }
        }
    }
}